import { render } from "./manage-footer-contact.vue?vue&type=template&id=046e6ec2"
import script from "./manage-footer-contact.vue?vue&type=script&lang=js"
export * from "./manage-footer-contact.vue?vue&type=script&lang=js"

import "./manage-footer-contact.vue?vue&type=style&index=0&id=046e6ec2&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__